module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-fff text-center"
  }, [_c('backTitleBar', {
    attrs: {
      "isBackClose": true,
      "isLogOut": true
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "main-img",
    attrs: {
      "src": _vm.mainImg,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "margin-top": "3.1rem"
    }
  }, _vm._l((_vm.shopTypeList), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "flex1 text-center click",
      on: {
        "click": function($event) {
          return _vm.chooseType(item)
        }
      }
    }, [_c('img', {
      staticClass: "type-img",
      attrs: {
        "src": item.img,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "mt-20 fs-28 color-333"
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e9d129a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/shop/register/chooseShopType.vue
// module id = RNyo
// module chunks = 51